import React, { useState } from "react";
import axios from "axios";
import "./UploadReceiptModal.css";

const UploadReceiptModal = ({ isOpen, onClose, fetchReceipts }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [receipt, setReceipt] = useState(null);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
    if (!allowedTypes.includes(file.type)) {
      setError("Only JPG, JPEG, or PNG files are allowed.");
      setReceipt(null);
      return;
    }

    if (file.size > 2 * 1024 * 1024) {
      setError("File size should be under 2MB.");
      setReceipt(null);
      return;
    }

    setReceipt(file);
    setError("");
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");
  setMessage("");
  setProgress(0);

  if (!name || !email || !receipt) {
    setError("All fields are required.");
    return;
  }

  const formData = new FormData();
  formData.append("account_name", name);
  formData.append("gmail", email);
  formData.append("receipt", receipt);

  setLoading(true);

  let uploadFinished = false;

  try {
    await axios.post("https://backend.aubattle.com/api/receipts/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (progressEvent) => {
        const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        setProgress(percent);

        if (percent === 100 && !uploadFinished) {
          uploadFinished = true;

          // ✅ Upload complete, show success manually
          setShowSuccess(true);
          setMessage("Receipt uploaded successfully!");
          setName("");
          setEmail("");
          setReceipt(null);
          fetchReceipts?.();

          setTimeout(() => {
            setShowSuccess(false);
            setMessage("");
            setProgress(0);
            setLoading(false);
            onClose();
          }, 3000);
        }
      },
    });
  } catch (err) {
    console.error("❌ Upload error:", err);
    setError("Something went wrong. Please try again.");
    setLoading(false);
  }
};


  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        {showSuccess && (
          <div className="success-overlay">
            <div className="success-content">
              <div className="checkmark-container">
                <div className="checkmark">✓</div>
                <div className="fireworks">
                  {[...Array(6)].map((_, i) => (
                    <div key={i} className="firework"></div>
                  ))}
                </div>
              </div>
              <h3 className="success-title">Success!</h3>
              <p className="success-message">Receipt uploaded successfully</p>
              <div className="sparkles">
                <span className="sparkle">✨</span>
                <span className="processing-text">Processing your receipt...</span>
                <span className="sparkle">✨</span>
              </div>
            </div>
          </div>
        )}

        <h2>Upload Payment Receipt</h2>
        <p>Please provide your payment proof for verification.</p>

        {error && <p className="error">{error}</p>}
        {message && !showSuccess && <p className="success">{message}</p>}

        {progress > 0 && loading && (
          <div className="progress-container">
            <div className="progress-text">Uploading: {progress}%</div>
            <div className="progress-bar">
              <div className="progress-fill" style={{ width: `${progress}%` }}></div>
            </div>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Enter your account name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            disabled={loading}
            className="form-input"
          />

          <input
            type="email"
            placeholder="Enter your Gmail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
            className="form-input"
          />

          <input
            type="file"
            accept="image/jpeg, image/jpg, image/png"
            onChange={handleFileChange}
            disabled={loading}
            className="file-input"
          />

          {receipt && (
            <div className="file-selected">✓ {receipt.name} selected</div>
          )}

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? (
              <span className="loading-content">
                <span className="spinner"></span> Uploading... {progress}%
              </span>
            ) : (
              "Submit Receipt"
            )}
          </button>
        </form>

        <button className="close-btn" onClick={onClose} disabled={loading}>
          ×
        </button>
      </div>
    </div>
  );
};

export default UploadReceiptModal;
